/* HTTP PDF export — streams the backend-generated PDF (API_CONTRACT.md). */
import { API_BASE_URL, getToken } from './httpClient'
import { ApiError } from './store'

export async function exportTripPdf(tripId: string, template = 'classic'): Promise<Blob> {
  const token = getToken()
  const res = await fetch(`${API_BASE_URL}/trips/${tripId}/export/pdf?template=${template}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  })
  if (!res.ok) {
    let message = res.statusText
    try {
      const body = await res.json()
      message = body?.error?.message ?? message
    } catch {
      /* non-JSON error body */
    }
    throw new ApiError(res.status, message)
  }
  return res.blob()
}

export async function exportTripFilm(tripId: string, style = 'classic'): Promise<Blob> {
  const token = getToken()
  const res = await fetch(`${API_BASE_URL}/trips/${tripId}/export/film?style=${style}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  })
  if (!res.ok) {
    let message = res.statusText
    try {
      const body = await res.json()
      message = body?.error?.message ?? message
    } catch {
      /* non-JSON error body */
    }
    throw new ApiError(res.status, message)
  }
  return res.blob()
}
